import React, { useEffect, useState } from "react";
import _ from "lodash";
import moment from "moment";
import {
  Layout,
  Space,
  PageHeader,
  Divider,
  Card,
  Row,
  Col,
  Radio,
  Table,
  Avatar,
  DatePicker,
  Button,
  Grid,
  Collapse,
  Empty,
} from "antd";
import OverviewCard from "../../components/Card/OverviewKpiCard";
import Table_Icon from "../../assets/images/table.svg";
import Packet_Icon from "../../assets/images/packet.svg";
import Bike_Icon from "../../assets/images/bike.svg";
import Customer_Icon from "../../assets/images/customer_red.svg";
import Menu_Icon from "../../assets/images/menu_red.svg";
import Order_Icon from "../../assets/images/order_bagred.svg";
import Revenue_Icon from "../../assets/images/revenue_red.svg";
import RatingLayout from "../../components/Layout/RatingLayout";
import DashboardService from "../../services/DashboardService";
import LineGraph from "./Kpi_Dashboard/lineGraph";
import "./kpi.scss";
import { getLocalISODate } from "../../utils";
import { Typography } from "antd";

const { Text } = Typography;

const { Content } = Layout;
const { useBreakpoint } = Grid;
const { Panel } = Collapse;

const KPIDashboard = () => {
  const [size, setSize] = useState("week");
  const [data, setData] = useState({});
  const [showPopular, setShowPopular] = useState(true);
  const [fromDate, setFromDate] = useState(
    moment().startOf("week").format("DD-MM-YYYY"),
  );
  const [toDate, setToDate] = useState(
    moment().endOf("week").format("DD-MM-YYYY"),
  );
  const screens = useBreakpoint();

  const getData = () => {
    DashboardService.getDashboardKpi(
      moment(fromDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
      moment(toDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
    ).then((res) => {
      setData(res);
    });
  };

  useEffect(() => {
    getData();
  }, [toDate, fromDate]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div style={{ display: "flex" }}>
            <div className="name_text">{record.name}</div>
          </div>
        );
      },
    },
    {
      title: "Orders Delivered",
      dataIndex: "total_orders_delivered",
      key: "total_orders_delivered",
    },
    {
      title: "Avg. Distance",
      dataIndex: "average_distance",
      key: "average_distance",
    },
    {
      title: "Avg. Delivery time",
      dataIndex: "average_delivery_time",
      key: "average_delivery_time",
    },
    {
      title: "Miles/min",
      dataIndex: "miles_per_minute",
      key: "miles_per_minute",
    },
  ];
  const column2 = [
    {
      title: "NAME OF ITEM",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div className="flex">
            <Avatar
              shape="square"
              size={50}
              src={record?.item_photo}
              style={{ marginRight: "20px" }}
            />
            <div className="item-name">{record?.item_name}</div>
          </div>
        );
      },
    },
    {
      title: "UNITS SOLD",
      dataIndex: "units_sold",
      key: "units_sold",
    },
    {
      title: "%AGE OF SALE",
      dataIndex: "percentange_of_sale",
      key: "percentange_of_sale",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="name_text red">
              {record?.percentange_of_sale?.toFixed(2)}%
            </div>
          </div>
        );
      },
    },
  ];
  const getColor = (rating) => {
    switch (rating) {
      case 1:
        return "#BD1B04";
      case 2:
        return "#BD5204";
      case 3:
        return "#D7C200";
      case 4:
        return "#8DA400";
      case 5:
        return "#0B8617";
      default:
        return "#0B8617";
    }
  };
  const onFilterDateChange = (date, dateString, field) => {
    if (field === "starDate") {
      setFromDate(moment(dateString, "MMM DD, YYYY"));
    } else {
      setToDate(moment(dateString, "MMM DD, YYYY"));
    }
    setSize("");
  };
  const onPeriodChange = (e) => {
    setSize(e.target.value);
    setFromDate(moment().startOf(e.target.value).format("DD-MM-YYYY"));
    setToDate(moment().endOf(e.target.value).format("DD-MM-YYYY"));
  };
  const onReset = () => {
    setSize("week");
    setFromDate(moment().startOf("week").format("DD-MM-YYYY"));
    setToDate(moment().endOf("week").format("DD-MM-YYYY"));
  };
  const roundingTheData = (tableData) => {
    return tableData?.map((itm) => ({
      ...itm,
      average_delivery_time: _.round(itm.average_delivery_time, 2),
      miles_per_minute: _.round(itm.miles_per_minute, 2),
      average_distance: _.round(itm.average_distance, 2),
    }));
  };
  return (
    <Layout className={`${screens.md && "u-page-layout"}`}>
      <Content className="w-full kpi_dboard page-padding">
        <Space className="w-full" direction="vertical">
          <PageHeader
            title={
              <Text className="responsive-text">
                Table Status ({getLocalISODate()})
              </Text>
            }
            className="page-header"
            extra={[
              <>
                <Row
                  gutter={[16, 16]} // horizontal and vertical spacing
                  justify="start"
                  align="middle"
                >
                  {/* Date Pickers */}
                  {screens.md && (
                  <Col>
                    <div
                      className="flex"
                      style={{ border: size ? "0px" : "2px solid red" }}
                    >
                      <div className="">
                        <DatePicker
                          name="starDate"
                          allowClear={false}
                          onChange={(date, dString) =>
                            onFilterDateChange(date, dString, "starDate")
                          }
                          value={moment(fromDate, "DD-MM-YYYY")}
                          format="MMM DD, YYYY"
                        />
                      </div>
                      {!screens.md && <div className="mx-2 pt-1">&nbsp;&nbsp;to&nbsp;&nbsp;</div>}
                      <div className="">
                        <DatePicker
                          name="endDate"
                          allowClear={false}
                          onChange={(date, dString) =>
                            onFilterDateChange(date, dString, "endDate")
                          }
                          value={moment(toDate, "DD-MM-YYYY")}
                          format="MMM DD, YYYY"
                        />
                      </div>
                     
                      <Button
                        type={size ? "dashed" : "primary"}
                        onClick={onReset}
                      >
                        Reset
                      </Button>
                      
                    </div>
                  </Col>
                  )}
                  <Col>
                    <div>
                      <Radio.Group value={size} onChange={onPeriodChange}>
                        <Radio.Button value="week" className="pos-radio-button">
                          Weekly
                        </Radio.Button>
                        <Radio.Button value="month">Monthly</Radio.Button>
                        <Radio.Button
                          value="year"
                          className="online-radio-button"
                        >
                          Total
                        </Radio.Button>
                      </Radio.Group>
                    </div>
                  </Col>
                </Row>
              </>,
            ]}
          />
        </Space>
        <div className="text-left flex flex_wrap p-1">
          <div>
            <OverviewCard
              title={_.round(data?.table_status_today || 0) + " min"}
              subTitle="Today"
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={_.round(data?.table_status_weekly || 0) + " min"}
              subTitle="Weekly"
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={_.round(data?.table_status_monthly || 0) + " min"}
              subTitle="Monthly"
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={_.round(data?.table_status_ytd || 0) + " min"}
              subTitle="YTD"
              className="min_kpi_card_size"
            />
          </div>
        </div>
        <Divider plain></Divider>

        {!screens.md &&
        
        <>
       <div className="flex flter-date-kpi">Filter Date:</div>
          <Row >
                  <Col>
                    <div
                      className="flex"
                      style={{ border: size ? "0px" : "2px solid red" }}
                    >
                      <div className="">
                        <DatePicker
                          name="starDate"
                          allowClear={false}
                          onChange={(date, dString) =>
                            onFilterDateChange(date, dString, "starDate")
                          }
                          value={moment(fromDate, "DD-MM-YYYY")}
                          format="MMM DD, YYYY"
                        />
                      </div>
                      <div className="mx-2 pt-1">&nbsp;&nbsp;to&nbsp;&nbsp;</div>
                      <div className="">
                        <DatePicker
                          name="endDate"
                          allowClear={false}
                          onChange={(date, dString) =>
                            onFilterDateChange(date, dString, "endDate")
                          }
                          value={moment(toDate, "DD-MM-YYYY")}
                          format="MMM DD, YYYY"
                        />
                      </div>
                     
                      
                    </div>
                  </Col>
                  </Row>
                  <Divider plain></Divider>
                  
                  
        </>}

        <Space className="w-full" direction="vertical">
          <PageHeader
            className="page-header"
            title={
              <Text className="responsive-text">
                Data ({moment(fromDate, "DD-MM-YYYY").format("Do MMM YYYY")} -{" "}
                {moment(toDate, "DD-MM-YYYY").format("Do MMM YYYY")})
              </Text>
            }
            extra={[]}
          />
        </Space>
        <div className="text-left flex flex_wrap p-1">
          <div>
            <OverviewCard
              title={_.round(data?.avg_dine_in_revenue) || 0}
              subTitle="Avg. Revenue per Order"
              subview="- Dine in"
              icon={Table_Icon}
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={_.round(data?.avg_delivery_revenue, 2) || 0}
              subTitle="Avg. Revenue per Order"
              subview="- Delivery"
              icon={Bike_Icon}
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={_.round(data?.avg_takeaway_revenue, 2) || 0}
              subTitle="Avg. Revenue per Order"
              subview="- Takeaway"
              icon={Packet_Icon}
              className="min_kpi_card_size"
            />
          </div>
        </div>

        <Divider plain />

        <Space className="w-full" direction="vertical">
          <PageHeader
            className="page-header"
            title={
              <Text className="responsive-text">
                Average Delivery Time - Branch wise
              </Text>
            }
            extra={[]}
          />
        </Space>
        <div className="text-left flex flex_wrap p-1">
          {data?.avg_delivery_time_mins?.map((itm) => {
            return (
              <div>
                <OverviewCard
                  title={(_.round(itm.average_delivery_time) || "0") + " min"}
                  subTitle={itm.name}
                  className="min_kpi_card_size"
                />
              </div>
            );
          })}
        </div>
        <Divider plain />

        <Space className="w-full" direction="vertical">
          <PageHeader
            className="page-header p-1"
            title={
              <Text className="responsive-text">
                Average Delivery Time - Driver wise
              </Text>
            }
            extra={[]}
          />
        </Space>
        <div className="p-1">
          {screens.md ? (
            <Table
              columns={columns}
              dataSource={roundingTheData(data?.delivery_time_per_driver) || []}
              className="discount-table waitlist-table overflow-auto"
            />
          ) : (
            <div>
              {data?.delivery_time_per_driver?.length === 0 ?
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                :
              data?.delivery_time_per_driver?.map((record) => (
                <Collapse
                  bordered={false}
                  defaultActiveKey={[screens.md ? "issues" : ""]}
                  expandIconPosition="end"
                  className="review-list-collapse"
                >
                  <Panel
                    key="issues"
                    header={
                      <div className="flex">
                        <Avatar
                          shape="square"
                          size={50}
                          src={record?.item_photo}
                          style={{ marginRight: "20px" }}
                        />
                        <div className="item-name">{record?.item_name}</div>
                      </div>
                    }
                  >
                    <div className="flex space-between">
                      <div> Orders Delivered </div>{" "}
                      <div> {record.total_orders_delivered}</div>{" "}
                    </div>
                    <div className="flex space-between">
                      <div> Avg. Distance </div>{" "}
                      <div> {record.average_distance}</div>{" "}
                    </div>
                    <div className="flex space-between">
                      <div> Avg. Delivery time </div>{" "}
                      <div> {record.average_delivery_time}</div>{" "}
                    </div>
                    <div className="flex space-between">
                      <div> Miles/min </div>{" "}
                      <div> {record.miles_per_minute}</div>{" "}
                    </div>
                  </Panel>
                </Collapse>
              ))}
            </div>
          )}
        </div>
        <Divider plain />

        <Space className="w-full" direction="vertical">
          <PageHeader
            className="page-header p-1"
            title="Other KPIs"
            extra={[]}
          />
        </Space>

        <div className="text-left flex flex_wrap p-1">
          <div>
            <OverviewCard
              title={data?.total_menu_item}
              subTitle="Total Menu Items"
              image={Menu_Icon}
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={data?.total_order}
              subTitle="Total Orders"
              image={Order_Icon}
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={data?.total_customer}
              subTitle="Total Customers"
              image={Customer_Icon}
              className="min_kpi_card_size"
            />
          </div>
          <div>
            <OverviewCard
              title={data?.total_revenue ? "$ " + data?.total_revenue : "0"}
              subTitle="Total Revenue"
              image={Revenue_Icon}
              className="min_kpi_card_size"
            />
          </div>
        </div>
        <Row className="text-left tips-card-margin p-1" gutter={16}>
          <Col style={{ width: "100%", height: 450 }} className="m-1">
            <Card
              bordered={false}
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <h1 className="p-1">Revenue</h1>
              <LineGraph revenue_overview={data?.revenue_overview || []} />
            </Card>
          </Col>
        </Row>

        <div className="text-left flex flex_wrap item_align">
          <div className={` ${screens.md ? "container_min p-1" : "p-1 w-full"}`}>
            {screens.md ? (
              <Card
                title="Branch wise sales"
                bordered={false}
                style={{ width: "100%", height: "100%", overflow: "auto" }}
              >
                <div>
                  {data?.sales_by_branch?.map((item) => {
                    return (
                      <div className="server_items">
                        <div className="flex">
                          <Avatar
                            shape="square"
                            size={50}
                            src={item.logo_url}
                            style={{ marginRight: "20px" }}
                          />
                          <div>
                            <div className="item-name">{item.name}</div>
                            <div className="item-units">
                              {" "}
                              Unit sold:{" "}
                              <span className="unit">
                                {item.sales?.units_sold}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="item-price">
                          ${item.sales?.revenue || 0}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card>
            ) : (
              <>
                <Space className="w-full" direction="vertical">
                  <PageHeader
                    className="page-header p-1"
                    title={
                      <Text className="responsive-text">Branch wise sales</Text>
                    }
                    extra={[]}
                  />
                </Space>
                {data?.sales_by_branch?.map((record) => (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={[""]}
                    expandIconPosition="end"
                    className="review-list-collapse"
                  >
                    <Panel
                      key="sales"
                      header={
                        <div className="flex">
                          <Avatar
                            shape="round"
                            size={50}
                            src={record?.logo_url}
                            style={{ marginRight: "20px" }}
                          />
                          <div className="item-name">{record?.name}</div>
                        </div>
                      }
                    >
                      <div className="flex space-between">
                        <div> Units Sold </div>{" "}
                        <div> {record?.units_sold}</div>{" "}
                      </div>
                      <div className="flex space-between">
                        <div> Total Sales </div>{" "}
                        <div> ${record?.revenue ?? 0}</div>{" "}
                      </div>
                    </Panel>
                  </Collapse>
                ))}
              </>
            )}
          </div>
          <div className={` ${screens.md ? "container_min p-1" : "p-1 w-full"}`}>
            {screens.md ? (
              <Card
                title={
                  showPopular ? (
                    <div>
                      <span className="red">Popular Items </span>
                      <span
                        onClick={() => {
                          setShowPopular(false);
                        }}
                        className="cursor-pointer"
                      >
                        | Least Popular Items
                      </span>
                    </div>
                  ) : (
                    <div>
                      <span
                        onClick={() => {
                          setShowPopular(true);
                        }}
                        className="cursor-pointer"
                      >
                        Popular Items |{" "}
                      </span>
                      <span className="red">Least Popular Items</span>
                    </div>
                  )
                }
                bordered={false}
                style={{ width: "100%", height: "100%" }}
              >
                <div>
                  <Table
                    columns={column2}
                    dataSource={
                      (data &&
                        data[
                          showPopular ? "popular_items" : "unpopular_items"
                        ]) ||
                      []
                    }
                    className="popular_list-table"
                    pagination={false}
                  />
                </div>
              </Card>
            ) : (
              <>
                <Space className="w-full" direction="vertical">
                  <PageHeader
                    className="page-header p-1"
                    title={
                      <Text className="responsive-text">Popular Items </Text>
                    }
                    extra={[]}
                  />
                </Space>
                {data?.popular_items?.length === 0 ?
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                :
                data?.popular_items?.map((record) => (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={[""]}
                    expandIconPosition="end"
                    className="review-list-collapse"
                  >
                    <Panel
                      key="sales"
                      header={
                        <div className="flex">
                          <Avatar
                            shape="round"
                            size={50}
                            src={record?.item_photo}
                            style={{ marginRight: "20px" }}
                          />
                          <div className="item-name">{record?.item_name}</div>
                        </div>
                      }
                    >
                      <div className="flex space-between">
                        <div> %AGE OF SALES </div>{" "}
                        <div> {record?.units_sold}</div>{" "}
                      </div>
                      <div className="flex space-between">
                        <div> Total Sales </div>{" "}
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div className="name_text red">
                              {record?.percentange_of_sale?.toFixed(2)}%
                            </div>
                          </div>
                        </div>{" "}
                      </div>
                    </Panel>
                  </Collapse>
                ))}
              </>
            )}
          </div>
        </div>
        <div className="text-left overflow-auto">
          <div className={` ${screens.md ? "container_min p-1" : "p-1"}`}>
            {screens.md ? (
              <Card
                title="Top Rated Servers"
                bordered={false}
                style={{ width: "100%", height: "100%", overflow: "auto" }}
              >
                <div>
                  {data?.top_rated_servers?.map((item) => {
                    return (
                      <div className="server_items">
                        <div className="flex">
                          <Avatar
                            size={50}
                            src={item.photo_url}
                            style={{ marginRight: "20px" }}
                          />
                          <div>
                            <div className="item-name">{item.name}</div>
                            <div className="item-units">
                              {" "}
                              Tables served:{" "}
                              <span className="unit">{item.table_served}</span>
                            </div>
                          </div>
                        </div>
                        <div className="item-price">
                          <RatingLayout
                            rating={item.rating}
                            color={getColor(_.round(item.rating))}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Card>
            ) : (
              <>
                <Space className="w-full" direction="vertical">
                  <PageHeader
                    className="page-header p-1"
                    title={
                      <Text className="responsive-text">Top Rated Servers</Text>
                    }
                    extra={[]}
                  />
                </Space>
                {data?.top_rated_servers?.map((record) => (
                  <Collapse
                    bordered={false}
                    defaultActiveKey={[""]}
                    expandIconPosition="end"
                    className="review-list-collapse"
                  >
                    <Panel
                      key="sales"
                      header={
                        <div className="flex">
                          <Avatar
                            shape="round"
                            size={50}
                            src={record?.photo_url}
                            style={{ marginRight: "20px" }}
                          />
                          <div className="item-name">{record?.name}</div>
                        </div>
                      }
                    >
                      <div className="flex space-between">
                        <div> Tables served </div>{" "}
                        <div> {record?.tables_served}</div>{" "}
                      </div>
                      <div className="flex space-between">
                        <div> Rating </div>
                        <div className="item-price">
                          <RatingLayout
                            rating={record?.rating}
                            color={getColor(_.round(record?.rating))}
                          />
                        </div>{" "}
                      </div>
                    </Panel>
                  </Collapse>
                ))}
              </>
            )}
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default KPIDashboard;
